import $ from '@rover/globals/jquery';

const showFailure = () => {
  $('.js-email-capture-footer-form-failure').fadeIn('fast');
};

const showThanks = response => {
  if (response.status !== 'success') {
    showFailure();
    return;
  }

  $('.js-email-capture-footer-form-failure').fadeOut('fast');
  $('.js-email-capture-footer-form-initial').fadeOut('fast', () => {
    $('.js-email-capture-footer-form-thanks').fadeIn('fast');
  });
};

const initializeEmailCaptureForm = () => {
  $('.js-email-capture-form').ajaxForm({
    success: showThanks,
  });
};

const init = () => {
  initializeEmailCaptureForm();
};

export default {
  init,
};



// WEBPACK FOOTER //
// ./js/components/email_capture_footer_form.js